"use client";

import { PointMaterial, Points } from "@react-three/drei";
import { Canvas, useFrame } from "@react-three/fiber";
import * as random from "maath/random";
import { useRef, useState } from "react";
import * as THREE from "three";

/**
 *  @note 「React instrumentation encountered an error: Error: Invalid argument not valid semver ('' received).」が発生するが、
 *        ブラウザ拡張機能「React DevTools」の影響であり、本番環境での影響はないため、対応しない
 */
export default function StarrySky() {
  return (
    // 空の色
    <div className="pointer-events-none absolute inset-0 h-96 bg-STARSKY">
      {/* 星（星団）のレンダリング */}
      <Canvas camera={{ position: [0, 0, 1] }}>
        <Stars />
      </Canvas>
    </div>
  );
}

/**
 * 星（星団）のレンダリング
 */
function Stars() {
  const ref = useRef<THREE.Points>(null!);

  //------------
  // 設定情報
  //------------
  const STAR_COUNT = 200;
  const STAR_SIZE = 0.005;
  const STAR_COLOR = "#ffa0e0";
  const SPHERE_RADIUS = 1.0;

  const [sphere] = useState<Float32Array>(() => {
    //------------
    // 星の数や星団の大きさはここで設定
    //------------
    const starNum = new Float32Array(STAR_COUNT * 3); // 3の倍数とすること（しないとエラー発生）
    const sphereInfo = {
      radius: SPHERE_RADIUS, // 星団の半径
    };

    return random.inSphere(starNum, sphereInfo) as Float32Array;
  });

  useFrame((_, delta) => {
    //------------
    // 星の移動速度はここで設定
    // @note deltaを割る数を小さくすると速くなる
    //------------
    ref.current.rotation.x -= delta / 100;
    ref.current.rotation.y -= delta / 50;
  });

  return (
    <group rotation={[0, 0, Math.PI / 4]}>
      <Points
        ref={ref}
        positions={sphere}
        stride={3}
        frustumCulled={false}
      >
        {/* 星の色や大きさはここで指定 */}
        <PointMaterial
          transparent
          color={STAR_COLOR}
          size={STAR_SIZE}
          sizeAttenuation={true}
          depthWrite={false}
        />
      </Points>
    </group>
  );
}
